import React from "react";
import { RemocalWidget, shouldShowRemocalWidget } from "@jsq/common-components";
import { RichEmptyState } from "@jsq/ds/core";
import { emptyState, emptyStateWrapper } from "./styles_vanilla.css";

/**
 * Shown when client-level Treasury permissions are enabled and the user has no
 * Treasury access on any workspace. Mirrors MissingPermissionState.
 */
export const TreasuryEmptyState: React.FC = () => {
  return (
    <div className={emptyStateWrapper} data-testid="treasury-empty-state">
      {shouldShowRemocalWidget() && <RemocalWidget />}
      <RichEmptyState
        className={emptyState}
        description={
          <>
            You do not have Treasury access for any client workspaces. Contact your customer
            admin to request access.
          </>
        }
        illustration="searching"
        title="Treasury Access Not Configured"
      />
    </div>
  );
};
